import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"logout"},[_c('h1',[_vm._v("Abmeldung")]),_c(VProgressLinear,{staticClass:"mb-4",attrs:{"color":"primary","indeterminate":""}}),_c('p',[_vm._v(" Du wirst sicher abgemeldet... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }